<template>
    <div>
        <div class="lesson-boxNow"
                @click="goDetail(item.url,item.classId,item.classTitle)"
                v-for="(item, index) in goodList"
                :key="index">
<!--            <el-row class="el-row-out">-->
<!--                <el-col :span="24">-->
                        <el-image style="height: 51vh"
                                  :src="'data:image/'+item.imgType+';base64,'+item.picSub">
                            <div slot="error" class="image-slot">
                                <i class="el-icon-picture-outline"></i>
                            </div>
                        </el-image>
<!--                </el-col>-->
<!--            </el-row>-->
        </div>
        <el-row class="last-img-first"></el-row>
    </div>
</template>
<script>
    import {formatDate} from "@api/date.js";
    export default {
        name: "ClassNowList",
        props: {
            goodList: {
                type: Array,
                default: () => []
            },
            isSort: {
                type: Boolean,
                default: true
            }
        },
        data: function () {
            return {};
        },
        methods: {
            // 商品详情跳转
            goDetail(url,id,classTitle) {
                this.$router.push({path: "/ClassTj",query:{classId:id,url:url,className:classTitle}});
                // console.log("url:" + url);
                // var params = {
                //     classId: id,
                //     url:url
                // }
                // submitLession(params).then(response => {
                //     console.log(response.rsp)
                //     if(url!==""){
                //         if (response.rsp === "false") {
                //             this.$message.warning('请刷新页面并完成团组织绑定！');
                //         } else {
                //             window.location.href = url
                //         }
                //
                //     }else{
                //         this.$message.warning('新的一期课程发布中,请等待！');
                //         console.log(console.log(url))
                //     }
                    // window.open(url, "_self","toolbar=yes, location=yes, directories=no, status=no, menubar=yes, scrollbars=no, resizable=no, copyhistory=yes, width=400, height=400");
                // });
                // window.open(url, "_self");
            }
        },
        filters: {
            formatDateDay(time) {
                var date = new Date(time);
                return formatDate(date, "yyyy-MM-dd");
            }
        }
    };
</script>

<style>
    .lesson-boxNow {
        margin-top:1vh ;
        text-align: center;
        margin-left: 5vh;
        margin-right: 5vh;
        background-color: #66c5f5;
        height:70%
        /*margin-top: 1vh;*/
    }

    .lesson-img {
        width: 100%;
        border-radius: 5px;
    }

    .el-row-out {
        /*margin-bottom: 1vh;*/
        background-color: #66c5f5;
    }
    .last-img-first{
        height: 20vh;
        width: 100%;
        position: relative;
        text-align: center;
        background-size: 100% 100%; /*按比例缩放*/
        background-image: url("../assets/images/classChannel/3.jpg");
    }
</style>
